import React from "react";
import axios from "axios";

import { BACKEND_CONFIG } from "../../config/consts";
import AlertErrorMessage from "../../components/AlertErrorMessage";
import { ValidationProvider } from "../../validation/validation-provider";

import { PaymentMethod } from "./PaymentMethod";
import { BillingAddress } from "./BillingAddress";
import ThankYou from "./ThankYou";

import "../../styles/collect-payment-page.scss";

export class CollectPaymentPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isPANReady: false,
      address: undefined,
      paymentData: null,
      isPaymentMethodValid: true,
      errorMessage: undefined,
      timeStamp: 0,
      submitted: false,
    };

    this.paymentForm = null;
    this.iFrame = null;
  }

  componentDidMount() {
    if (!this.props.bindRequest.policyQuoteId) this.props.history.push("/");

    window.onbeforeunload = function (event) {
      return "You have unsubmitted data. Are you sure you want to leave this page?";
    };
  }

  componentWillUnmount() {
    window.onbeforeunload = undefined;
  }

  isCreditCardMethod() {
    return this.props.bindRequest.method === "Credit / Debit Card";
  }

  updatePaymentData(data) {
    this.paymentFormContext = this.paymentForm.current.getChildContext();
    this.setState({
      paymentData: { ...this.state.paymentData, ...data },
      isPaymentMethodValid: !(
        this.paymentFormContext._errors &&
        this.paymentFormContext._errors.length > 0
      ),
    });
  }

  handlePANValidation(isValid) {
    if (isValid) this.iFrame.tokenize();
    else if (this.state.isPANReady) this.setState({ isPANReady: false });
  }

  applyToken(data) {
    this.setState({
      paymentData: { ...this.state.paymentData, ...data },
      isPANReady: true,
    });
  }

  handleSendRequest() {
    let isValid = ValidationProvider.isValid(this.paymentForm);

    if (!isValid) {
      this.setState({ isPaymentMethodValid: false });

      return;
    }

    if (!this.state.address) {
      this.setState({
        errorMessage: "Please enter address",
        timeStamp: this.state.timeStamp + 1,
      });

      return;
    }
    var paymentData = this.isCreditCardMethod()
      ? {
          FirstName: this.state.paymentData.firstName,
          MiddleName: this.state.paymentData.middleName,
          LastName: this.state.paymentData.lastName,
          Token: this.state.paymentData.token,
          CardCompany: this.state.paymentData.cardCompany,
          ExpirationMonth: this.state.paymentData.selectedMonth,
          ExpirationYear: this.state.paymentData.selectedYear,
          CVV: this.state.paymentData.cvv,
          ClientId: this.props.bindRequest.clientId,
          Downpayment: this.props.bindRequest.downpayment,
          Address: this.state.address,
          ReferenceNumber: this.state.paymentData.referenceNumber,
        }
      : {
          FirstName: this.state.paymentData.firstName,
          MiddleName: this.state.paymentData.middleName,
          LastName: this.state.paymentData.lastName,
          Token: this.state.paymentData.token,
          RoutingNumber: this.state.paymentData.routingNumber,
          Address: this.state.address,
          ClientId: this.props.bindRequest.clientId,
          Downpayment: this.props.bindRequest.downpayment,
          ReferenceNumber: this.state.paymentData.referenceNumber,
        };

    axios({
      url: BACKEND_CONFIG.apiUrl + "panels/submit-bind-with-payment-request",
      method: "post",
      data: JSON.stringify({
        EffectiveDate: this.props.bindRequest.effectiveDate,
        PaymentPlan: this.props.bindRequest.plan,
        PaymentMethod: this.props.bindRequest.method,
        QuoteId: this.props.bindRequest.policyQuoteId,
        Note: this.props.bindRequest.comments,
        Files: this.props.bindRequest.files,
        AutoPay: this.props.bindRequest.autoPay,
        ...paymentData,
      }),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then(() => {
        this.setState({ submitted: true });
      })
      .catch((error) => {
        alert(error);
      });
  }

  setPaymentForm(f) {
    this.paymentForm = f;
  }

  handleAddressChange(address) {
    this.setState({ address: address });
  }

  render() {
    return (
      <div className="mb-5">
        {this.state.submitted ? (
          <ThankYou />
        ) : (
          this.props.bindRequest.policyQuoteId && (
            <div className="collect-payment">
              <h1>Collect Payment</h1>
              <div className="collect-payment-content">
                <div className="white-content-box">
                  {this.state.errorMessage && (
                    <AlertErrorMessage
                      message={this.state.errorMessage}
                      onDismiss={() =>
                        this.setState({ errorMessage: undefined })
                      }
                      timestamp={this.state.timeStamp}
                    />
                  )}
                  <p className="information-head">Insured Name</p>
                  <div className="information-block">
                    <p>
                      <b>Quote ID: </b> {this.props.bindRequest.quoteId}
                    </p>
                    <p>
                      <b>Line: </b> {this.props.bindRequest.lob}
                    </p>
                    <p>
                      <b>Carrier: </b> {this.props.bindRequest.carrier}
                    </p>
                    <p>
                      <b>Effective Date: </b>
                      {this.props.bindRequest.effectiveDate
                        ? this.props.bindRequest.effectiveDate.toLocaleDateString(
                            undefined,
                            {
                              month: "2-digit",
                              day: "2-digit",
                              year: "numeric",
                            }
                          )
                        : ""}
                    </p>
                    <p>
                      <b>Payment Plan: </b>
                      {this.props.bindRequest.plan}
                    </p>
                  </div>
                  <PaymentMethod
                    isCreditCard={this.isCreditCardMethod()}
                    iFrameRef={(e) => {
                      this.iFrame = e;
                    }}
                    onPANValidate={(e) => this.handlePANValidation(e)}
                    onTokenize={(data) => this.applyToken(data)}
                    paymentForm={(f) => this.setPaymentForm(f)}
                    onUpdate={(d) => this.updatePaymentData(d)}
                  />
                  <BillingAddress
                    onAddressSelected={(address) =>
                      this.handleAddressChange(address)
                    }
                    clientId={this.props.bindRequest.clientId}
                  />
                </div>
                <button
                  disabled={
                    !(this.state.isPANReady && this.state.isPaymentMethodValid)
                  }
                  className="btn btn-primary float-right mt-3 px-4"
                  onClick={() => this.handleSendRequest()}
                >
                  Submit
                </button>
                <button
                  className="btn btn-default float-right mr-2 mt-3 px-4"
                  onClick={() => this.props.history.goBack()}
                >
                  Cancel
                </button>
              </div>
            </div>
          )
        )}
      </div>
    );
  }
}
